import { parseISO, compareDesc } from 'date-fns';
import { CaseType } from '@packages/models/api';

type CaseTypeName = CaseType['caseType'];

export const EXCLUDED_CASE_TYPES: CaseTypeName[] = ['CID/CVN'];

export function filterCaseTypes(
    caseTypes: CaseType[],
    excludedCaseTypes: CaseTypeName[] = EXCLUDED_CASE_TYPES
): CaseType[] {
    if (!caseTypes?.length) {
        return [];
    }
    return caseTypes?.filter((ct) => !excludedCaseTypes.includes(ct.caseType));
}

export function toBoolean(value: boolean | string | null | undefined): boolean {
    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (normalized === 'true') {
            return true;
        }
        if (normalized === 'false') {
            return false;
        }
    }

    return false;
}

export function isPrimaryCaseType(
    primaryCaseType: string,
    caseTypes: Array<{ caseType: string; isPrimary: boolean | string }>,
    targetCaseType: string
): boolean {
    if (primaryCaseType) {
        return primaryCaseType === targetCaseType;
    }
    if (caseTypes && caseTypes.length) {
        return caseTypes.some((ct) => ct.caseType === targetCaseType && toBoolean(ct.isPrimary));
    }
    return false;
}

export function getLatestWorksheetSubmission(caseDetails: any, worksheetCaseType?: string) {
    const worksheetSubmissions = caseDetails?.worksheetSubmissions ?? [];
    const targetCaseType = (worksheetCaseType ?? '').trim().toUpperCase();

    const filteredSubmissions = worksheetCaseType
        ? worksheetSubmissions.filter(
              (submission: any) => String(submission?.worksheetCaseType ?? '').toUpperCase() === targetCaseType
          )
        : worksheetSubmissions;

    if (!filteredSubmissions.length) {
        return null;
    }

    const sortedSubmissions = [...filteredSubmissions].sort((a, b) =>
        compareDesc(parseISO(a?.lastUpdatedTimestamp), parseISO(b?.lastUpdatedTimestamp))
    );

    return sortedSubmissions[0] ?? null;
}

export function getLatestWorksheetSubmissionIds(
    caseDetails: any,
    worksheetCaseType?: string
): { worksheetId: string; submissionId: string } {
    const latest = getLatestWorksheetSubmission(caseDetails, worksheetCaseType);

    return {
        worksheetId: latest?.worksheetId ?? '',
        submissionId: latest?.submissionId ?? '',
    };
}
